<template>
  <div>
    <template v-if="!showBindJobNumberPage">
      <el-form
        class="login-form form-custom"
        :class="{ 'mgb-more': fromGuest }"
        ref="form"
        label-position="top"
        label-width="80px"
        @submit.native.prevent
        :hide-required-asterisk="true"
        :rules="rules"
        :model="form"
      >
        <!-- 表单 -->
        <el-row
          :class="{ fr: $i18n.locale === 'cn' }"
          :gutter="12"
          v-if="!isMergeLoginAndRegister"
        >
          <el-col :span="12">
            <!-- 名 -->
            <el-form-item
              class="form-item-primary"
              prop="firstName"
              :class="{ 'higher-height': $i18n.locale === 'en' }"
            >
              <BaseInput
                :autofocus="$i18n.locale === 'en' && !isMobile"
                :tabIndexNum="$i18n.locale === 'en' ? '1' : '2'"
                v-model="form.firstName"
                @blur="nameFilter('firstName')"
                :validate-event="Boolean(form.firstName)"
                :placeholer="$t('login.register.firstName')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 姓 -->
            <el-form-item
              class="form-item-primary"
              prop="lastName"
              :class="{ 'higher-height': $i18n.locale === 'en' }"
            >
              <BaseInput
                :autofocus="$i18n.locale === 'cn' && !isMobile"
                :tabIndexNum="$i18n.locale === 'en' ? '2' : '1'"
                v-model="form.lastName"
                @blur="nameFilter('lastName')"
                :validate-event="Boolean(form.lastName)"
                :placeholer="$t('login.register.lastName')"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 手机号码 -->
        <el-form-item class="form-item-primary" prop="phone">
          <BaseInput
            v-if="hasBanner || isMergeLoginAndRegister"
            v-model="form.phone"
            :disabled="fromPlatform"
            :tabIndexNum="'3'"
            :validate-event="Boolean(form.phone)"
            :placeholer="$t('login.register.enterYourPhone')"
            :maxLength="11"
            @input="handlePhoneChange"
          >
            <template #prepend>
              <el-select
                :disabled="true"
                v-model="form.pretel"
                style="width: 100px"
              >
                <el-option
                  v-for="item in preTelList"
                  :value="item"
                  :label="'+' + item"
                  :key="'+' + item.toString()"
                  >+ {{ item }}</el-option
                >
              </el-select>
              <!-- <div v-else>+{{ form.pretel }}</div> -->
            </template>
          </BaseInput>
          <div v-else class="input-custom-disabled">
            +{{ form.pretel }}&nbsp;&nbsp;{{ form.phone | phoneFormat }}
          </div>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item class="form-item-primary" prop="verification_code">
          <BaseInput
            v-model.trim="form.verification_code"
            :maxlength="smsLength"
            :validate-event="Boolean(form.verification_code)"
            :placeholer="$t('login.register.labelCode')"
            :tabIndexNum="'4'"
            @focus="changeCode"
            @input="handleCodeChange"
          >
            <template #btn>
              <VerificationCode
                ref="verification"
                @click="sendCode"
                :account="form.phone"
                :from="'register'"
                :isActive="activeSms"
              />
            </template>
            <template #prefix>
              {{ $t('login.register.verificationCode') }}
            </template>
          </BaseInput>
        </el-form-item>

        <el-form-item
          v-if="!isMergeLoginAndRegister"
          class="form-item-primary"
          prop="password"
          :class="{ 'higher-height': $i18n.locale === 'en' }"
        >
          <!-- 密码 -->
          <BaseInput
            v-model.trim="form.password"
            type="password"
            @keyup.native="pwdFilter"
            @keyup.enter.native="submit"
            :validate-event="Boolean(form.password)"
            :placeholer="$t('login.register.setPass')"
            :tabIndexNum="'5'"
          />
        </el-form-item>
      </el-form>
      <!-- 协议及订阅 -->
      <template v-if="hasAgreement">
        <Agreement v-model="form.agreement" class="aggrement-unset" />
      </template>

      <el-button
        class="button-custom"
        tabindex="6"
        @click="submit"
        v-track="{
          type: 'click',
          name: `${$route.params.type || 'phone'}.${
            $route.params.step || 'account'
          }.${fromEvent ? 'enterEvent' : 'registerUser'}`,
        }"
        >{{ detailSubmitText }}</el-button
      >
      <div class="user-custom-tips" v-if="isMergeLoginAndRegister">
        <p>{{ customContent.Owndesc }}</p>
      </div>
    </template>
    <template v-else>12313</template>
  </div>
</template>

<script>
import VerificationCode from '@/components/login/VerificationCode.vue'
import BaseMixin from '@/mixins/BaseMixin'
import { checkPhone, checkPassword, checkSMSCode } from '@/utils/validate-rules'
import { getBusinessType } from '@/constant'
import store from '@/store'
import tipsIcon from '@/assets/images/login/tips.svg'
import Agreement from '@/components/login/Agreement'
import handleSaveAndJump from '@/utils/saveLogin.js'
import _throttle from 'lodash/throttle'
import { getItem, setItem } from '@/utils/storage-main'
import { handleBusinessRegiser } from '@/utils/mutiple.js'
import { param2Obj } from '@/utils/utils.js'
import { gotinTrack } from '@frontend/gotin-track'
import { isNeedHandleSMSActive } from '@/utils/consts'
import hrService from '@/http/porsche-hr'

export default {
  name: '',
  props: {},
  mixins: [BaseMixin],
  data() {
    return {
      showBindJobNumberPage: false,
      form: {
        phone: '',
      },
      isWrong: false,
      registeredPhone: '',
      tipsIcon: tipsIcon,
      dialogVisible: false,
    }
  },

  components: { VerificationCode, Agreement },

  computed: {
    smsLength() {
      return store.state.smsLength
    },
    activeSms() {
      return store.state.activeSms
    },
    passAccount() {
      return checkPhone(this.currentAccount)
    },
    isMergeLoginAndRegister() {
      return getBusinessType().isMergeLoginAndRegister
    },
    customContent() {
      return getBusinessType()
    },
    hasAgreement() {
      return !this.fromGuest
    },
    detailSubmitText() {
      return this.$t('login.loginPage.porscheLogin')
    },
    rules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('login.register.labelRegisteredPhone'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              // 已知已注册号码不再提交请求进行多次校验
              this.hasChangePhone()
              if (this.registeredPhone)
                return callback(new Error(this.$t('login.register.exists')))

              if (checkPhone(value)) {
                // 检测是否注册
                if (!getBusinessType().isMergeLoginAndRegister) {
                  await this.handleCheckUserValidator(value, callback)
                } else {
                  callback()
                }
              } else {
                return callback(
                  new Error(this.$t('login.resetPassword.validPhone'))
                )
              }
              return callback(
                new Error(this.$t('login.resetPassword.validPhone'))
              )
            },
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: this.$t('login.email.register.ruleLastName'),
          },
        ],
        firstName: [
          {
            required: true,
            message: this.$t('login.email.register.ruleFirstName'),
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.email.register.setPassPop'),
          },
          {
            validator: (rule, value, callback) => {
              if (!checkPassword(value)) {
                callback(
                  new Error(this.$t('login.email.register.showPasswordRules'))
                )
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.register.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
  },
  methods: {
    // 验证码输入监听
    handleCodeChange: _throttle(function (val) {
      if (checkSMSCode(val)) {
        gotinTrack.standaloneSendData({
          name: `form.code_checked`,
          params: { value: val },
        })
      }
    }, 500),
    // 手机号输入监听
    handlePhoneChange: _throttle(function (val) {
      if (isNeedHandleSMSActive()) {
        const isValid = checkPhone(val)

        this.$store.commit('SET_SMSISACTIVE', isValid)

        if (isValid) {
          gotinTrack.standaloneSendData({
            name: `form.phone_checked`,
            params: { value: val },
          })
        }
      }
    }, 500),
    // 修改电话号码
    hasChangePhone() {
      if (this.form.phone !== this.registeredPhone) this.registeredPhone = ''
    },
    changeCode() {
      this.isWrong = false
    },
    sendCode() {
      if (this.registeredPhone) {
        return
      }
      this.$refs['form'].validateField('phone', (vaild) => {
        if (!vaild) {
          if (isNeedHandleSMSActive()) {
            this.$store.commit('SET_SMSISACTIVE', false)
          }
          this.$refs['verification'].send()
        }
      })
    },

    creatParams() {
      const { phone, password, firstName, lastName, verification_code } =
        this.form

      return {
        phone,
        password,
        firstName,
        lastName,
        verification_code,
      }
    },
    hasConfirmArgeement() {
      if (this.hasAgreement && !this.form.agreement) {
        this.$message.error(this.$t('login.register.acceptTermsPop'))
        return false
      }
      return true
    },
    showTips() {
      this.dialogVisible = true
    },
    handleFinalPath(path) {
      return `${process.env.VUE_APP_SITE}/cn/${path}`
    },
    async handleCheckUserValidator(value, callback) {
      try {
        let data = await store.dispatch('CheckUser', {
          user_name: value,
        })
        console.log(data)
        this.registered = false
        return callback()
        // if (data.data === true) {
        //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //   this.registered = false
        //   return callback()
        // } else {
        //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //   this.registered = true
        //   return callback(new Error(this.$t('login.register.exists')))
        // }
      } catch (error) {
        return callback()
      }
    },

    loginSuccess(successData) {
      this.isLogin
        ? this.$message.success(this.$t('login.loginPage.success'))
        : this.$message.success(this.$t('login.register.success'))
      handleSaveAndJump(successData.data)
    },

    async hrLogin(successData) {
      const { token } = successData.data
      setItem('Authorization', token)
      const res = await hrService.getStaffInfo()
      if (res.code === 0) {
        // 没有工号信息
        if (!res.data.id) {
          this.$store.commit('setLoginResultData', successData.data)
          await this.$router.replace({
            path: 'hr-job-number',
            query: { ...this.$route.query },
          })
        } else {
          this.loginSuccess(successData)
        }
      }
    },

    async fetchRegisterData(params) {
      return await store.dispatch('RegisterByPhone', params)
    },
    // 提交注册/加入活动/下一步
    submit: _throttle(
      function () {
        // google analytics
        // current 911
        const { name } = param2Obj(window.location.href)
        if (name && (name === 'porsche911' || name === 'porschetaycan')) {
          this.$gtag.event('EnterDreamvers', {
            event_category: 'Button',
            event_label: 'Dreamvers',
          })
        }

        if (!this.hasConfirmArgeement()) {
          return false
        }

        this.$refs['form'].validate(async (valid) => {
          try {
            if (valid) {
              let successData
              // 获取参数
              let params = this.creatParams()
              if (getBusinessType().isNeedTagedSource) {
                params.source = getBusinessType().unionId
              }
              // 分享功能与具体业务方无关，存在相应的字段传递就可以
              if (getBusinessType().isMergeLoginAndRegister) {
                const { phone, verification_code } = this.form
                let { data } = await store.dispatch('CheckUser', {
                  user_name: this.form.phone,
                })
                if (data) {
                  this.isLogin = false
                  // 未注册
                  let registerParams = {
                    firstName: '',
                    lastName: '',
                    password: '',
                    source: getBusinessType().unionId,
                    phone,
                    verification_code,
                  }
                  successData = await handleBusinessRegiser(
                    getItem('business'),
                    registerParams,
                    this.fetchRegisterData
                  )
                } else {
                  this.isLogin = true
                  let loginParams = {
                    user_name: phone,
                    verification_code,
                    source: getBusinessType().unionId,
                  }
                  successData = await store.dispatch(
                    'userSmsLogin',
                    loginParams
                  )
                }
              } else {
                successData = await handleBusinessRegiser(
                  getItem('business'),
                  params,
                  this.fetchRegisterData
                )
              }
              if (successData.code === 0) {
                if (name === 'hr') {
                  this.hrLogin(successData)
                } else {
                  this.loginSuccess(successData)
                }
              }
            }
          } catch (error) {
            console.log(error, 'error tips')
            if (error.code === 11010) {
              this.isWrong = true
              this.$refs['form'].validateField('verification_code')
            }
          }
        })
      },
      500,
      { trailing: false }
    ),
  },
}
</script>
<style lang="scss" scoped>
.button-custom {
  border-radius: 12px;
  background: linear-gradient(
      180deg,
      #e97a89 -14.96%,
      #e24a5e 30.92%,
      #dc253d 100%
    ),
    #d5001c;
  font-size: 16px;
  color: #f7f7fc !important;
  font-weight: 700;
}
.form-custom {
  margin-top: 24px;
}
.user-custom-tips {
  font-size: 12px;
  line-height: 20px;
  margin-top: 12px;
  color: #b5b4ba;
}
.aggrement-unset {
  margin-top: 12px;
  margin-bottom: 16px;
}
.custom-tips-njcb {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #5c5c5c;
  margin-bottom: 16px;
}
.custom-tips-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #5c5c5c;
  margin-bottom: 16px;
  .njcb-tips-icon {
    width: 20px;
    height: 20px;
  }

  .custom-tips-title {
    margin-left: 10px;
  }
  .custom-sub-title {
    color: #ed2e79;
  }
}
.tips-icons {
  font-size: 22px;
  color: #f2555e;
}
.dialog-desc-pro {
  margin-top: 8px;
}
</style>
